import React, { ReactNode } from 'react'
import { getIconByName, IconNameType } from '../../icons'
import FreeText from '../FreeText/FreeText'
import Icon from '../Icon/Icon'
import Permalink from '../Permalink/Permalink'
import styles from './IconLink.module.scss'

export type IconLinkProps = {
  children: ReactNode
  iconName: IconNameType
  to: string
  isExternal?: boolean
}

export default function IconLink(props: IconLinkProps) {
  const { children, iconName, to, isExternal } = props
  return (
    <div className={styles.iconLink}>
      <span className={styles.icon}>
        <Icon icon={getIconByName(iconName)} size={24} />
      </span>
      <Permalink to={to} className={styles.link} isExternal={isExternal}>
        <FreeText type="md" color="primary" as="span">
          {children}
        </FreeText>
      </Permalink>
    </div>
  )
}
